import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductBoxCloseIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M20.8457 6.74757L12.3457 2.33447C12.1289 2.22217 11.8711 2.22217 11.6543 2.33447L3.1543 6.74757C2.9058 6.87647 2.75 7.13327 2.75 7.41307V16.2402C2.75 16.5205 2.9058 16.7763 3.1543 16.9062L11.6543 21.3203C11.7627 21.376 11.8814 21.4043 12 21.4043C12.1186 21.4043 12.2373 21.376 12.3457 21.3203L20.8457 16.9062C21.0937 16.7763 21.25 16.5205 21.25 16.2402V7.41307C21.25 7.13327 21.0938 6.87647 20.8457 6.74757ZM12 3.84517L19.1447 7.55437L16.5212 8.91587L9.3772 5.20687L12 3.84517ZM11.5 19.5499L4.25 15.7842V8.36607L11.5 12.1311V19.5499ZM12 11.2637L4.8562 7.55397L7.7496 6.05187L14.8938 9.76107L12 11.2637ZM19.75 15.7842L12.5 19.5499V12.1311L19.75 8.36687V15.7842Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductBoxCloseIcon.displayName = 'ProductBoxCloseIcon';
